/** 정적 사이트 이미지 (public/images/site → 빌드 후 /images/site/...) */
const BASE = '/images/site';

export const SITE_IMAGES = {
  logo: `${BASE}/logo.png`,
  greetingDirector: `${BASE}/greeting-director.png`,
  greetingSignature: `${BASE}/greeting-signature.png`,
  pageBanner: `${BASE}/page-banner.jpg`,
  productBanner: `${BASE}/product-banner.png`,
  heroControlOfFibrosis: `${BASE}/hero-control-of-fibrosis.jpg`,
  heroAimpDx2: `${BASE}/hero-aimp-dx2.jpg`,
  heroGlucoseLeucine: `${BASE}/hero-glucose-leucine.jpg`,
  heroAarsTherapeutic: `${BASE}/hero-aars-therapeutic.png`,
  heroMultiTrna: `${BASE}/hero-multi-trna.png`,
  partnerZymediaBanner: `${BASE}/partner-zymedia-banner.jpg`,
  partnerAibi: `${BASE}/partner-aibi.png`,
  partnerBioart: `${BASE}/partner-bioart.jpg`,
  partnerMsict: `${BASE}/partner-msict.png`,
  partnerYsu: `${BASE}/partner-ysu.png`,
  partnerZymedi: `${BASE}/partner-zymedi.png`,
  partnerIvim: `${BASE}/partner-ivim.png`,
  partnerMetapore: `${BASE}/partner-metapore.png`,
  partnerMbd: `${BASE}/partner-mbd.png`,
  partnerDaewoong: `${BASE}/partner-daewoong.png`,
  partnerJwBio: `${BASE}/partner-jw-bio.png`,
} as const;

/** 구 WordPress 미디어 URL → 로컬 정적 경로 */
export const LEGACY_SITE_IMAGE_MAP: Record<string, string> = {
  'https://target.re.kr/wp-content/uploads/2016/06/logo_106x60.png': SITE_IMAGES.logo,
  'https://biocon.re.kr/wp-content/uploads/2016/06/%EB%8B%A8%EC%9E%A501.png': SITE_IMAGES.greetingDirector,
  'https://biocon.re.kr/wp-content/uploads/2016/06/단체사진01.png': SITE_IMAGES.greetingDirector,
  'https://biocon.re.kr/wp-content/uploads/2015/11/sk_sign-e1464764204594.png': SITE_IMAGES.greetingSignature,
  'https://seventhqueen.com/themes/kleo/demo-business/wp-content/uploads/sites/2/2014/09/landing-bg.jpg':
    SITE_IMAGES.pageBanner,
  'https://kleo.seventhqueen.com/demo-business/wp-content/uploads/sites/2/2014/09/landing-bg.jpg':
    SITE_IMAGES.pageBanner,
  'https://biocon.re.kr/wp-content/uploads/2016/06/DSC_0202.jpg': SITE_IMAGES.productBanner,
  '/images/site/product-banner.jpg': SITE_IMAGES.productBanner,
  'https://target.re.kr/wp-content/uploads/2023/06/control_of_fibrosis-scaled.jpg':
    SITE_IMAGES.heroControlOfFibrosis,
  'https://target.re.kr/wp-content/uploads/2023/06/AIMP-DX2-scaled.jpg': SITE_IMAGES.heroAimpDx2,
  'https://target.re.kr/wp-content/uploads/2020/01/%EC%8A%A4%ED%81%AC%EB%A6%B0%EC%83%B7_2020-01-20_19-05-47.jpg':
    SITE_IMAGES.heroGlucoseLeucine,
  'https://target.re.kr/wp-content/uploads/2019/05/AARSs_synthecise.png': SITE_IMAGES.heroAarsTherapeutic,
  'https://target.re.kr/wp-content/uploads/2019/04/Screen-Shot-2019-04-18-at-12.14.53.png':
    SITE_IMAGES.heroMultiTrna,
  'https://target.re.kr/wp-content/uploads/2024/01/zymedia.jpg': SITE_IMAGES.partnerZymediaBanner,
  'https://target.re.kr/wp-content/uploads/2024/12/aibilogo.png': SITE_IMAGES.partnerAibi,
  'https://target.re.kr/wp-content/uploads/2015/06/banner02_2.jpg': SITE_IMAGES.partnerBioart,
  'https://biocon.re.kr/wp-content/uploads/2019/07/partner_msict.png': SITE_IMAGES.partnerMsict,
  'https://biocon.re.kr/wp-content/uploads/2020/03/partner_ysu.png': SITE_IMAGES.partnerYsu,
  'https://target.re.kr/wp-content/uploads/2022/09/zymedi.png': SITE_IMAGES.partnerZymedi,
  'https://biocon.re.kr/wp-content/uploads/2019/07/partner_ivim.png': SITE_IMAGES.partnerIvim,
  'https://biocon.re.kr/wp-content/uploads/2019/07/partner_metapore.png': SITE_IMAGES.partnerMetapore,
  'https://biocon.re.kr/wp-content/uploads/2019/07/partner_mbd_new.png': SITE_IMAGES.partnerMbd,
  'https://biocon.re.kr/wp-content/uploads/2019/07/partner_daewoong.png': SITE_IMAGES.partnerDaewoong,
  'https://biocon.re.kr/wp-content/uploads/2019/07/partner_jw_bio.png': SITE_IMAGES.partnerJwBio,
};
